export default __webpack_public_path__ + "static/media/empty.b00a6dad.svg";